import React from "react";
import { Lock, ShieldCheck, Zap, Crown } from "lucide-react";

const Card = ({ children, label, className = "" }) => (
  <span aria-label={label} title={label}
    className={`inline-flex items-center justify-center h-6 min-w-[38px] px-1.5 rounded-[5px] bg-white text-[10px] font-extrabold tracking-tight ${className}`}>
    {children}
  </span>
);

export const PaymentMarks = () => (
  <div data-testid="payment-marks" className="flex flex-wrap items-center gap-1.5">
    <Card label="Visa" className="text-[#1a1f71] italic text-[11px]">VISA</Card>
    <Card label="Mastercard">
      <span className="w-3.5 h-3.5 rounded-full bg-[#eb001b]" /><span className="w-3.5 h-3.5 rounded-full bg-[#f79e1b] -ml-1.5 mix-blend-multiply" />
    </Card>
    <Card label="American Express" className="!bg-[#2e77bc] text-white">AMEX</Card>
    <Card label="Apple Pay" className="!bg-black text-white border border-[#3a3a3a] font-semibold"><span className="text-[11px] mr-0.5">●</span>Pay</Card>
    <Card label="Google Pay" className="text-[#3c4043] font-semibold">
      <span className="text-[#4285f4]">G</span>&nbsp;Pay
    </Card>
  </div>
);

const BADGES = [
  { icon: Lock, title: "Secure checkout", sub: "Powered by Stripe" },
  { icon: ShieldCheck, title: "SSL encrypted", sub: "256-bit HTTPS" },
  { icon: Zap, title: "Instant delivery", sub: "Download right after payment" },
  { icon: Crown, title: "100% exclusive rights", sub: "One buyer, then it's gone" },
];

export const TrustBadges = ({ compact = false, className = "" }) => (
  <div data-testid={compact ? "trust-badges-compact" : "trust-badges"} className={className}>
    {compact ? (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[11px] text-[#9ca3af]">
        {BADGES.map(({ icon: Icon, title }) => (
          <span key={title} className="inline-flex items-center gap-1.5"><Icon className="w-3.5 h-3.5 text-[#22c55e]" />{title}</span>
        ))}
      </div>
    ) : (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {BADGES.map(({ icon: Icon, title, sub }) => (
          <div key={title} className="flex items-center gap-3 rounded-xl border border-[#2a2a2a] bg-[#0f0f0f] px-4 py-3">
            <span className="w-9 h-9 rounded-lg bg-[#22c55e]/10 border border-[#22c55e]/30 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-[#22c55e]" />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold leading-tight">{title}</p>
              <p className="text-xs text-[#6b7280] leading-tight mt-0.5">{sub}</p>
            </div>
          </div>
        ))}
      </div>
    )}
    <div className={`flex flex-wrap items-center gap-3 ${compact ? "mt-2.5" : "mt-4"}`}>
      <PaymentMarks />
      {!compact && <span className="text-xs text-[#6b7280]">Card details are handled by Stripe. We never see or store them.</span>}
    </div>
  </div>
);
